import { render } from "./ChiusureGiornaliereAdminTable.vue?vue&type=template&id=218fcf74&scoped=true"
import script from "./ChiusureGiornaliereAdminTable.vue?vue&type=script&lang=js"
export * from "./ChiusureGiornaliereAdminTable.vue?vue&type=script&lang=js"

import "./ChiusureGiornaliereAdminTable.vue?vue&type=style&index=0&id=218fcf74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218fcf74"]])

export default __exports__